// Copyright (c) 2026 PGNS LLC

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { initSentry } from '@/lib/sentry';
import './fonts.css';
import '@pgns/ui/styles';
import './globals.css';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
